// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const StatusProg0Icon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <circle cx={12} cy={12} r={9} stroke="currentColor" strokeWidth={2.25} />
  </svg>,
  "StatusProg0",
);
export default StatusProg0Icon;
